import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Input, LoadingBlock, ErrorState } from "@/components/ds";

export default function InternalAuditLogs() {
  const [action, setAction] = useState("");
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["internal-audit", action],
    queryFn: () => api.internalAuditLogs({ limit: "50", ...(action ? { action } : {}) }),
  });

  return (
    <div className="space-y-4" data-testid="internal-audit-logs">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Audit Logs</h1>
        <p className="text-sm text-slate-500">Sensitive platform actions. Secrets, passwords and payment data are never recorded.</p>
      </div>
      <div className="max-w-xs">
        <Input placeholder="Filter by action (e.g. login, access)" value={action}
          onChange={(e) => setAction(e.target.value)} data-testid="audit-filter" />
      </div>
      {isLoading ? <LoadingBlock rows={6} /> : isError || !data ? <ErrorState onRetry={refetch} /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-slate-100 text-left text-xs text-slate-400">
              <th className="px-4 py-2">When</th><th className="px-4 py-2">Action</th>
              <th className="px-4 py-2">Entity</th><th className="px-4 py-2">Actor</th></tr></thead>
            <tbody data-testid="audit-rows">
              {data.logs.map((l: any, i: number) => (
                <tr key={l.id || i} className="border-b border-slate-50">
                  <td className="whitespace-nowrap px-4 py-2 text-slate-500">{String(l.created_at || "").slice(0, 19).replace("T", " ")}</td>
                  <td className="px-4 py-2 font-medium text-slate-800">{l.action}</td>
                  <td className="px-4 py-2 text-slate-500">{l.entity_type}{l.entity_id ? `:${String(l.entity_id).slice(-8)}` : ""}</td>
                  <td className="px-4 py-2 text-slate-500">{l.actor_profile_id ? String(l.actor_profile_id).slice(-10) : "system"}</td>
                </tr>
              ))}
              {data.logs.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-slate-400">No matching audit entries.</td></tr>}
            </tbody>
          </table>
          <div className="px-4 py-2 text-xs text-slate-400">{data.total.toLocaleString()} total entries</div>
        </div>
      )}
    </div>
  );
}
